import axios from "axios";

import * as endpoints from "../endpoints";
import { constants } from "../constants";

const baseUrl = constants.baseURL;

export const sendSalaryToMaskoreshet = async (salaryId) => {
  return axios({
    method: 'post',
    url: `${endpoints.Maskoreshet.SEND_SALARY}/${salaryId}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};
